import React from "react";
import { Link } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const NavbarOnboarding = ({ className }) => {
    const { t } = useTranslation();
    return (
        <div className={`navbar-onboarding ${className}`}>
            <div className="container">
                <Link to="/">
                    <img
                        className="logo-p-only"
                        alt="Logo p only"
                        src="https://c.animaapp.com/D1wmOhGo/img/logo-p-only-1-1@2x.png"
                    />

                </Link>
                <div className="text-wrapper">{t("productTitle")}</div>
            </div>
        </div>
    );
};
